/**
 * Fingerprint of an English source string. Stored with each translation so
 * Translation Admin can flag translations whose English has since changed.
 * FNV-1a 32-bit — stable, fast, not security-sensitive.
 */
export function sourceHash(text: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}
